/**
 *
 * View to provide a drop-zone form. This should potentially be
 * merged with other view forms as we develop them.
 *
 * This view also adds a listener on the html container to provide
 * class for basing styles. This listener should also potentially
 * be moved to a new module if we develop it further.
 *
 */

var sw              = require('js/lib/sw');
var ShapewaysView   = require('js/lib/views/ShapewaysView');
var _               = require('underscore');
var $               = require('js/sw-jquery/sw-jquery');

var HIDDEN_CLASS = 'sw--is-hidden';

var ModelMaterialDragAndDropUpload = ShapewaysView.extend({

  events: {
    'drop': 'onFileDrop',
    'dragstart': 'stopDrop',
    'dragend': 'stopDrop',
    'dragleave': 'onDragLeave',
    'dragover': 'onDragOver',
    'drag': 'onDrag',
    'change [data-sw-model-material-drag-and-drop-upload-file-input]': 'onFileChange'
  },

  swAttrs: {
    form: 'data-sw-model-material-drag-and-drop-upload-form',
    fileInput: 'data-sw-model-material-drag-and-drop-upload-file-input',
    dragAndDropAreaUpload: 'data-sw-model-material-drag-and-drop-upload-area',
    dragAndDropUploading: 'data-sw-model-material-drag-and-drop-upload-uploading',
    uploadProgressBar: 'data-sw-model-material-drag-and-drop-upload-progress-bar',
    errorContainer: 'data-sw-model-material-drag-and-drop-upload-file-error',
    moreThanOneFileError: 'data-sw-model-material-drag-and-drop-upload-file-count-error',
    fileFormatError: 'data-sw-model-material-drag-and-drop-upload-file-format-error',
    fileTooLargeError: 'data-sw-model-material-drag-and-drop-upload-file-size-error',
    fileGenericError: 'data-sw-model-material-drag-and-drop-upload-generic-error',
    fileError: 'data-sw-model-material-drag-and-drop-upload-error'
  },

  stopDrop: function(e) {
    e.preventDefault();
  },

  onDragEnter: function(e) {
    this.stopDrop(e);
  },

  onDragOver: function(e) {
    this.stopDrop(e);
  },

  onDrag: function(e) {
    this.stopDrop(e);
  },

  onDragLeave: function(e) {
    this.stopDrop(e);
  },

  onFileChange: function(e) {
    this.uploadFiles(e.target.files);
  },

  onFileDrop: function(e) {
    this.stopDrop(e);
    this.uploadFiles(e.originalEvent.dataTransfer.files);
  },

  getFormData: function(fileInputName) {
    var formData = new window.FormData();
    var values = this.cachedElements.$form.serializeArray();

    _.each(values, function(valueObj) {
      if (valueObj.name === fileInputName) {
        return;
      }

      formData.append(valueObj.name, valueObj.value);
    });

    return formData;
  },

  /**
   * returns true if the upload is successful
   *
   * returns false if you exceed the drop limit
   *
   * @param files
   * @returns {boolean}
   */
  uploadFiles: function(files) {
    // Reset errors
    this.hideError();

    if (files.length > 1) {
      this.showError(this.cachedElements.$moreThanOneFileError);
      return false;
    }

    var file = _.first(files);
    if (!file) {
      return false;
    }

    var acceptedFileExtensionsAttr = this.cachedElements.$fileInput.attr('accept');
    if (acceptedFileExtensionsAttr) {
      var acceptedFileExtensions = acceptedFileExtensionsAttr.split(',');
      var re = /\.[^.]+?$/;
      // Get the file extension
      var extension = re.exec(file.name)[0];
      if (!extension || !_.contains(acceptedFileExtensions, extension.toLowerCase())) {
        this.showError(this.cachedElements.$fileFormatError);
        return false;
      }
    }

    var maxFileSize = this.cachedElements.$fileInput.attr('data-sw-max-file-size');
    if (maxFileSize && file.size > maxFileSize) {
      this.showError(this.cachedElements.$fileTooLargeError);
      return false;
    }

    var fileInputName = this.cachedElements.$fileInput.attr('name');
    var formData = this.getFormData(fileInputName);
    formData.append(fileInputName, file);

    this.setUploadingState();

    return this.makeRequest(file.name, formData);
  },

  /**
   * Switch to the state that shows the model being uploaded
   */
  setUploadingState: function() {
    this.cachedElements.$dragAndDropAreaUpload.addClass(HIDDEN_CLASS);
    this.cachedElements.$dragAndDropUploading.removeClass(HIDDEN_CLASS);
  },

  /**
   * Switch to the state that shows the form that allows the model to be uploaded
   */
  unsetUploadingState: function() {
    this.cachedElements.$uploadProgressBar.width(0);
    this.cachedElements.$dragAndDropAreaUpload.removeClass(HIDDEN_CLASS);
    this.cachedElements.$dragAndDropUploading.addClass(HIDDEN_CLASS);
  },

  /**
   * Show the error container and then the specific message provided.
   */
  showError: function($errorMessage, $message) {
    var $errorContainer = this.cachedElements.$errorContainer.removeClass(HIDDEN_CLASS);
    $errorMessage.removeClass(HIDDEN_CLASS);
    if (this.cachedElements.$fileError === $errorMessage && $message) {
      $errorMessage.html($message);
    }
    $errorContainer.css({opacity: 0}).animate({opacity: 1}, 500);
  },

  /**
   * Reset the error container to the initial state
   */
  hideError: function () {
    this.cachedElements.$errorContainer.addClass(HIDDEN_CLASS);
    this.cachedElements.$moreThanOneFileError.addClass(HIDDEN_CLASS);
    this.cachedElements.$fileFormatError.addClass(HIDDEN_CLASS);
    this.cachedElements.$fileTooLargeError.addClass(HIDDEN_CLASS);
    this.cachedElements.$fileGenericError.addClass(HIDDEN_CLASS);
  },

  /**
   *
   * @param filename
   * @param formData
   * @returns {*}
   */
  makeRequest: function(filename, formData) {
    var _this = this;
    var $form = this.cachedElements.$form;

    var ajaxParams =  {
      url: $form.attr('action'),
      type: $form.attr('method'),
      data: formData,
      processData: false,
      contentType: false,
      dataType: 'json',
      success: function(data) {
        // Animate the progress bar to complete in case it isn't already there
        _this.updateProgress(1);
        _this.$el.trigger('success', data);
        // Redirect if a redirectUrl is supplied
        if (data.message.redirectUrl) {
          window.location.assign(data.message.redirectUrl);
        }
      },
      error: function(jqXhr) {
        var response = JSON.parse(jqXhr.responseText);
        _this.$el.trigger('error', response);
        if (response) {
          _this.showError(_this.cachedElements.$fileError, response.error || response.message);
        } else {
          _this.showError(_this.cachedElements.$fileGenericError);
        }
        _this.unsetUploadingState();
      },
      /**
       *
       * Hook into XHR to update upload progress
       *
       * @returns {global.XMLHttpRequest|XMLHttpRequest}
       */
      xhr: function() {
        var xhr = new window.XMLHttpRequest();

        xhr.upload.addEventListener('progress', function(evt) {
          if (evt.lengthComputable) {

            var percentComplete = evt.loaded / evt.total;
            if (evt.loaded / evt.total > 0.99) {
              // Guess the amount of time the server will need to process
              // the model file based on size of the file
              var animateTime = 0.0002 * evt.total + 5000;
              _this.updateProgress(1, animateTime);
            } else {
              _this.updateProgress(percentComplete * 0.75);
            }
          }
        }, false);

        return xhr;
      }
    };

    return $.ajax(ajaxParams);
  },

  /**
   * Animate the progress bar
   *
   * @param percentComplete
   * @param animateTime
   */
  updateProgress: function(percentComplete, animateTime) {
    animateTime = animateTime || 200;
    var fullWidth = this.cachedElements.$uploadProgressBar.parent().outerWidth();
    this.cachedElements.$uploadProgressBar.stop().animate({width: Math.round(fullWidth * percentComplete)}, animateTime);
  }

});

module.exports = ModelMaterialDragAndDropUpload;